import React, { Component, Fragment } from 'react';
import ReactDataGrid from 'react-data-grid';
import moment from 'moment';
import { Field } from 'redux-form';
import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import { Toolbar, Data } from 'react-data-grid-addons';
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb, Dropdown, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import axios from 'axios';
import GenericSelection from '../Common/GenericSelection';

import { setSelectedBusinessUser } from '../../actions/settings_actions';
import BusinessUserEditModal from './businessUserEditModal';
import dateFilterRadios from '../Common/dateFilterRadios';
import Spinner from '../../components/Widgets/spinner';
import { Translate } from 'react-redux-i18n';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import { fetchBusinessUsersAPI, handleEditUserConfirm, verifyBusinessUser } from '../../actions/settings_actions';
import { toFromDates } from '../Common/cleanDates';
import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { ROOT_URL, isOLG, isSUN, isSW, isCCW } from '../../actions/root_url';

const daysSelection = [{
  label: '7 Days',
  value: 7,
}, {
  label: '30 Days',
  value: 30,
}, {
  label: '90 Days',
  value: 90,
}, {
  label: 'All',
  value: 'all',
}];

class BusinessUsersModal extends Component {
  constructor() {
    super();
    this.state = {
      bindModalVisibility: false,
      editBusinessDisable: false,

      phoneOptions: [],
      nameOptions: [],
      emailOptions: [],
      idOptions: [],
      selectedBind: null,

      curdep: {},
      businessUsersTable: {
        row: [],
        filters: {},
        isLoading: true,
      },
      businessUsersTableFilter: {
        fromDate: null,
        toDate: null,
        days: {
          label: '7 Days',
          value: 7,
        },
      },
      selectedRow: null,
      businessUserEditModal: {
        isVisible: false,
      }
    };
  }

  componentDidMount() {
    this.fetchDetailWithFilter();
    if (isOLG || isSUN) {
      this.props.fetchPaymentTerms();
    }
    let phoneOptions = [];
    let emailOptions = [];
    let nameOptions = [];
    let idOptions = [];
    if (isSW || isCCW) {
      axios({
        method: 'GET',
        // url: `${ROOT_URL}v1/customer/?Customer_id__IsActive=1&Company_id=1`,
        url: `${ROOT_URL}v1/customer/paginator?page=1&limit=99999999&IsActive=1&Company_id=1`,
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      })
        .then(res => {
          // console.log("data", res.data.record);
          res && res.data && res.data.record && res.data.record.map((r,i) => {
            emailOptions.push({label: r.email, value: r.Customer_id});
            nameOptions.push({label: r.Name, value: r.Customer_id});
            phoneOptions.push({label: r.Telephone, value: r.Customer_id});
            idOptions.push({label: r.CustomerNum, value: r.Customer_id});
          });
          this.setState({emailOptions, nameOptions, phoneOptions, idOptions});

        }, err => {
        })
    }
  }

  fetchDetailWithFilter = () => {
    const setState = this.setState.bind(this);
    let {
      days,
      fromDate,
      toDate,
    } = this.state.businessUsersTableFilter;
    if (days.value === 'all') {
      fetchBusinessUsersAPI(undefined, setState);
      return;
    }
    if (fromDate && toDate) days = { value: '-1' };
    const newDate = toFromDates(days.value, fromDate, toDate);
    fetchBusinessUsersAPI(newDate, setState);
  }

  renderTable() {
    if (this.state.businessUsersTable.isLoading) return <Spinner />
    else {
      // Parameters of the react-data-grid

      const getRows = () => {
        return Data.Selectors.getRows(this.state.businessUsersTable);
      }

      const getSize = () => {
        return getRows().length;
      }

      const rowGetter = rowIdx => {
        var rows = getRows();
        return rows[rowIdx];
      }

      const handleGridSort = (sortColumn, sortDirection) => {
        const businessUsersTable = Object.assign({}, this.state.businessUsersTable, { sortColumn, sortDirection });
        this.setState({businessUsersTable});
      };

      const handleFilterChange = (filter) => {
        let newFilters = Object.assign({}, this.state.businessUsersTable.filters);
        if (filter.filterTerm) {
          newFilters[filter.column.key] = filter;
        } else {
          delete newFilters[filter.column.key];
        }
        const businessUsersTable = { ...this.state.businessUsersTable, filters: newFilters };
        this.setState({businessUsersTable});
      }
  
      const onClearFilters = () => {
        // all filters removed
        const businessUsersTable = { ...this.state.businessUsersTable, filters: {} };
        this.setState({businessUsersTable});
      };

      //onRowClick will pass the data of clicked row to a component where the data can be edit
      const onRowClick = (index) => {
        // if (index === -1) return;
        // this.props.setSelectedBusinessUser(this.state.businessUsersTable.rows[index]);
        // this.setState({
        //   selectedRow: this.state.businessUsersTable.rows[index],
        // }, this.setModalOpen)
      }

      const businessUsersModalComponent = this;
      const statusFormatter = React.createClass({
        handleConfirmVerificationClick(event) {
          if (!isOLG || !isSUN) {
            event.stopPropagation();
            verifyBusinessUser(this.props.dependentValues)
              .then(res => {
                businessUsersModalComponent.fetchDetailWithFilter();
              })
              .catch(err => {
                if(typeof err.data === 'string') {
                  alert(err.data);
                  return
                }
                if(Array.isArray(err.data)) {
                  let message = '';
                  err.data.forEach((errMessage, idx) => {
                    message += `${idx + 1}: ${errMessage}.`
                  })
                  alert(message);
                  return
                }
                if(typeof err.data === 'object') {
                  let message = '';
                  for(let key in err.data) {
                    if(typeof err.data.key === 'string') {
                      message += `(${err.data.key}).`
                    }else {
                      for(var i = 0; i < err.data[key].length; i++) {
                        message += `(${key}: ${err.data[key][i]}).`
                      }
                    }
                  }
                  alert(message);
                }
                // alert(err.data);
              })
          }
        },
        render() {
          if (this.props.value) return <span><Translate value="Business_already_verified" /></span>;
          return (
            <Button bsStyle="success" onClick={e => this.handleConfirmVerificationClick(e)}><Translate value="confirm_verification" /></Button>
            );
        },
      });

      // Column difinition
      const columns = [
        {
          key: 'business_name',
          name: <Translate value="business_name" />,
          resizable: true,
          width: 200,
          sortable: true,
          filterable: true,
          getRowMetaData: row => row,
          formatter: ({value, dependentValues, index}) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
              onDoubleClick={() => {
                this.props.setSelectedBusinessUser(dependentValues);
                this.setState({
                  selectedRow: dependentValues,
                  editBusinessDisable: ((isSW || isCCW) && dependentValues.is_process) ? true : false,
                }, this.setModalOpen);
              }}
            >
              {value}
            </div>
          ),
        },
        {
          key: 'full_name',
          name: <Translate value="full_name" />,
          resizable: true,
          width: 150,
          sortable: true,
          filterable: true
        },
        {
          key: 'phone_number',
          name: <Translate value="phone_number" />,
          resizable: true,
          width: 150,
          sortable: true,
          filterable: true
        },
        {
          key: 'email',
          name: <Translate value="email" />,
          resizable: true,
          width: 220,
          sortable: true,
          filterable: true
        },
        {
          key: 'street',
          name: <Translate value="street" />,
          resizable: true,
          width: 200,
          sortable: true,
          filterable: true
        },
        ...(isSW || isCCW) ? [{
          key: 'is_process',
          name: <Translate value="status" />,
          resizable: true,
          width: 170,
          sortable: true,
          filterable: false,
          // formatter: statusFormatter,
          getRowMetaData: row => row,
          formatter: ({ value, dependentValues }) => (
            <div
              style={{ width: "100%", height: "100%", textAlign: "center" }}
            >
              {value && <div><Translate value="Business_already_verified" /></div>}
              {!value && <div 
             style={{cursor: 'pointer', color: 'green'}}
              onClick={() => {this.setState({bindModalVisibility: true, curdep: dependentValues, selectedBind: null})}}
              ><Translate value="confirm_verification" /></div>}
            </div>
          ),
        }] : [{
          key: 'is_process',
          name: <Translate value="status" />,
          resizable: true,
          width: 170,
          sortable: true,
          filterable: false,
          formatter: statusFormatter,
          getRowMetaData: row => row,
        }],
        // {
        //   key: 'is_process',
        //   name: <Translate value="status" />,
        //   resizable: true,
        //   width: 170,
        //   sortable: true,
        //   filterable: false,
        //   formatter: statusFormatter,
        //   getRowMetaData: row => row,
        // },
      ]

      return (
        <Col sm={12}><div style={{ maxWidth: '100%' }}>
          <ReactDataGrid
            onGridSort={handleGridSort}
            onAddFilter={handleFilterChange}
            onClearFilters={onClearFilters}
            rowKey='id'
            toolbar={<Toolbar enableFilter={true} />}
            onRowClick={onRowClick}
            columns={columns}
            rowHeight={25}
            minHeight={265}
            rowGetter={rowGetter}
            rowsCount={getSize()}
          />
        </div></Col>
      )
    }
  }

  generateDaysDropdownSelection = (daysSelection, currentSelected, handleDaysClick) => (
    <Dropdown id="dropdown-custom-1">
      <Dropdown.Toggle>
        {currentSelected.label}
      </Dropdown.Toggle>
      <Dropdown.Menu className="super-colors">
        {daysSelection.map(el => {
          return (
            <MenuItem onClick={() => handleDaysClick(el)}>{el.label}</MenuItem>
          )
        })}
      </Dropdown.Menu>
    </Dropdown>
  )

  handleDaysClick = el => {
    this.setState({
      businessUsersTableFilter: {
        fromDate: null,
        toDate: null,
        days: el,
      }
    }, () => {
      this.fetchDetailWithFilter();
    });
  }

  renderFilter = () => {
    return (
      <Row>
        <Col xs={1}>
          {this.generateDaysDropdownSelection(daysSelection, this.state.businessUsersTableFilter.days, this.handleDaysClick)}
        </Col>
        <Col xs={2}>
          <DateTimePicker
            id="from-datepicker"
            format="MM-DD-YY"
            onChange={(e) => {
              if (this.state.businessUsersTableFilter.toDate && e > this.state.businessUsersTableFilter.toDate) {
                return;
              }
              this.setState({ businessUsersTableFilter: { ...this.state.businessUsersTableFilter, fromDate: e } },
                () => {
                  if (this.state.businessUsersTableFilter.fromDate && this.state.businessUsersTableFilter.toDate) {
                    this.fetchDetailWithFilter();
                  }
                },
              );
            }}
            time={false}
            placeholder="Start"
            value={this.state.businessUsersTableFilter.fromDate}
          />
        </Col>
        <Col xs={2}>
          <DateTimePicker
            id="to-datepicker"
            format="MM-DD-YY"
            onChange={(e) => {
              if (e < this.state.businessUsersTableFilter.fromDate) {
                return;
              }
              this.setState({ businessUsersTableFilter: { ...this.state.businessUsersTableFilter, toDate: e } },
                () => {
                  if (this.state.businessUsersTableFilter.fromDate && this.state.businessUsersTableFilter.toDate) {
                    this.fetchDetailWithFilter();
                  }
                },
              );
            }}
            min={this.state.businessUsersTableFilter.fromDate}
            time={false}
            placeholder="End"
            value={this.state.businessUsersTableFilter.toDate}
          />
        </Col>
      </Row>
    )
  }

  handleVeriClick = (dep) => {
    verifyBusinessUser(dep)
      .then(res => {
        this.fetchDetailWithFilter();
        this.props.swRefresh();
        this.setState({bindModalVisibility: false});
      })
      .catch(err => {
          alert(err.data);
          return
      });
}

handleBind = () => {
  // https://sunway-scm.truckxi.com/api/v1/baseuser/business-convert/29?Customer_id=1
  let {curdep, selectedBind} = this.state;
  // if (selectedBind) {
  //   let temp = selectedBind.value;
  // }
  axios({
    method: 'POST',
    url: `${ROOT_URL}v1/baseuser/business-convert/${curdep.user_id}?Customer_id=${this.state.selectedBind}`,
    // https://sunway-scm.truckxi.com/api/v1/baseuser/business-convert/29?Customer_id=1
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
    .then(res => {
      alert("Account Bound");
      this.fetchDetailWithFilter();
      this.props.swRefresh();
      this.setState({bindModalVisibility: false});
    }, err => {
      alert(JSON.stringify(err.data));             
    })
}

  handleBusinessUserEditConfirm = (userDetail) => {
    handleEditUserConfirm(userDetail)
      .then(res => {
        if (isOLG || isSUN) {
          verifyBusinessUser(userDetail)
            .then(res => {
              this.setModalClose();
              this.fetchDetailWithFilter();
            })
            .catch(err => {
              if(typeof err.data === 'string') {
                alert(err.data);
                return
              }
              if(Array.isArray(err.data)) {
                let message = '';
                err.data.forEach((errMessage, idx) => {
                  message += `${idx + 1}: ${errMessage}.`
                })
                alert(message);
                return
              }
              if(typeof err.data === 'object') {
                let message = '';
                for(let key in err.data) {
                  if(typeof err.data.key === 'string') {
                    message += `(${err.data.key}).`
                  }else {
                    for(var i = 0; i < err.data[key].length; i++) {
                      message += `(${key}: ${err.data[key][i]}).`
                    }
                  }
                }
                alert(message);
              }
              // alert(err.data);
            })
        } else {
          this.setModalClose();
          this.fetchDetailWithFilter();
        }
      })
      .catch(err => {
      })
  }

  renderSkyLightStateless = () => (<SkyLightStateless
    dialogStyles={{ height: '450px' }}
    isVisible={this.state.businessUserEditModal.isVisible}
    onCloseClicked={this.setModalClose}
    title="Business Users Edit"
  >
    <BusinessUserEditModal user={this.state.selectedRow} swDisable={this.state.editBusinessDisable} cancel={this.setModalClose} confirm={this.handleBusinessUserEditConfirm} />
  </SkyLightStateless>)

  //Filter helper functions
  setFromDate = fromDate => this.setState({ businessUsersTableFilter: { ...this.state.businessUsersTableFilter, fromDate } });
  setToDate = toDate => this.setState({ businessUsersTableFilter: { ...this.state.businessUsersTableFilter, toDate } });
  setToRangeSearch = () => this.setState({ businessUsersTableFilter: { ...this.state.businessUsersTableFilter, days: '-1' } });

  //BusinessUserEdit Modal helper function
  setModalOpen = () => this.setState({ businessUserEditModal: { ...this.state.businessUserEditModal, isVisible: true } });
  setModalClose = () => this.setState({ businessUserEditModal: { ...this.state.businessUserEditModal, isVisible: false } });

  render() {
    const createPickerDialogStyle = {
      width: "600px",
      height: "430px",
      marginLeft: "-10%",
    };
    return (
      <ContentWrapper>
        <Grid style={{ width: '100%' }}>
          <Panel>
            {
              this.renderFilter()
            }
          </Panel>
          <Panel>
            <Row>
              {
                this.renderTable()
              }
            </Row>
          </Panel>
        </Grid>
        {
          this.renderSkyLightStateless()
        }
        <SkyLightStateless
          dialogStyles={createPickerDialogStyle}
          isVisible={this.state.bindModalVisibility}
          onCloseClicked={() => {
            this.setState({bindModalVisibility: false});
          }}
          title={<Translate value="user_choice" />}
        >
          <div className="centerStyle" style={{justifyContent: 'center', alignItems: 'center'}}>
            <div style={{marginBottom: '20px', fontSize: '14px', fontWeight: 'bold'}}>Select a customer to bind to this business user. </div>
          <div className="customer-group-selectionx2">
            <span style={{fontSize: '13px', fontWeight: 'bold'}}>Name: </span>
            <GenericSelection
                  options={this.state.nameOptions}
                  value={this.state.selectedBind}
                  setSelected={(e) => {
                    this.setState({ selectedBind: e.value })
                  }}
                />
          </div>
          <div className="customer-group-selectionx2">
            <span style={{fontSize: '13px', fontWeight: 'bold'}}>Cust. Number: </span>
            <GenericSelection
                  options={this.state.idOptions}
                  value={this.state.selectedBind}
                  setSelected={(e) => {
                    this.setState({ selectedBind: e.value })
                  }}
                />
          </div>
          <div className="customer-group-selectionx2">
          <span style={{fontSize: '13px', fontWeight: 'bold'}}>Phone: </span>
            <GenericSelection
                  options={this.state.phoneOptions}
                  value={this.state.selectedBind}
                  setSelected={(e) => {
                    this.setState({ selectedBind: e.value })
                  }}
                />
          </div>
          <div className="customer-group-selectionx2">
          <span style={{fontSize: '13px', fontWeight: 'bold'}}>Email: </span>
            <GenericSelection
                  options={this.state.emailOptions}
                  value={this.state.selectedBind}
                  setSelected={(e) => {
                    this.setState({ selectedBind: e.value })
                  }}
                />
          </div>
           
            <div style={{ marginTop: "30px" }}>
              <Button
                bsStyle="success"
                style={{marginRight: '10px'}}
                onClick={(event) => {
                  this.handleBind();
                }}
                disabled={!this.state.selectedBind}
              >
                {/* <em className="fa fa-plus" /> */}
                <Translate value="bind_customer" />
              </Button>
              <Button
                bsStyle="success"
                style={{marginRight: '10px'}}
                onClick={(event) => {
                  this.handleVeriClick(this.state.curdep);
                }}
                disabled={false}
              >
                <Translate value="create_new" />
              </Button>
              <Button
                bsStyle="danger"
                onClick={(event) => {
                  this.setState({bindModalVisibility: false});
                }}
                disabled={false}
              >
                <Translate value="cancel" />
              </Button>
            </div>
          </div>
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

const mapDispatchToProps = {
  setSelectedBusinessUser,
  fetchPaymentTerms,
};

export default connect(null, mapDispatchToProps)(BusinessUsersModal);



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/businessUsersModal.jsx